const formatDate = (inputDate, includeTime) => {
  if (!inputDate) return "";

  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  let date;

  // Check if the date contains a '/'
  if (inputDate.includes('/')) {
    // Manually parse the date parts
    const [dayStr, monthStr, yearStr] = inputDate.split('/');
    const day = parseInt(dayStr, 10);
    const month = parseInt(monthStr, 10) - 1; // JavaScript months are 0-based
    const year = parseInt(yearStr, 10);
    date = new Date(year, month, day);
  } else {
    // Use original logic
    date = new Date(inputDate);
  }

  const formattedDate = `${date.getDate()}-${months[date.getMonth()]}-${date.getFullYear()}`;

  if (includeTime) {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    return `${formattedDate} ${hours}:${minutes}:${seconds}`;
  }

  return formattedDate;
}

// Correct GMT+7 day start and end
const getDayStartISO = (dateStr) => {
  // Create a date at 00:00:00.000 in GMT+7, then convert to UTC (ISO)
  const [year, month, day] = dateStr.split('-').map(Number);
  // month-1 because JS months are 0-based
  const date = new Date(Date.UTC(year, month - 1, day, 0, 0, 0, 0));
  // Subtract 7 hours to get UTC equivalent of 00:00:00+07:00
  date.setUTCHours(date.getUTCHours() - 7);
  return date.toISOString();
};

const getDayEndISO = (dateStr) => {
  // Create a date at 23:59:59.999 in GMT+7, then convert to UTC (ISO)
  const [year, month, day] = dateStr.split('-').map(Number);
  const date = new Date(Date.UTC(year, month - 1, day, 23, 59, 59, 999));
  // Subtract 7 hours to get UTC equivalent of 23:59:59.999+07:00
  date.setUTCHours(date.getUTCHours() - 7);
  return date.toISOString();
};

// Helper to add days
function addDays(dateStr, days) {
  const d = new Date(dateStr);
  d.setDate(d.getDate() + days);
  return d.toISOString().slice(0, 10);
}

const get3AMRange = (dateStr) => {
  // Start: 3AM of dateStr (in GMT+7)
  const start = new Date(getDayStartISO(dateStr));
  start.setUTCHours(start.getUTCHours() + 3); // add 3 hours to UTC (so 03:00+07:00)
  // End: 2:59:59.999AM of next day (in GMT+7)
  const nextDay = addDays(dateStr, 1);
  const end = new Date(getDayStartISO(nextDay));
  end.setUTCHours(end.getUTCHours() + 3);
  end.setMilliseconds(end.getMilliseconds() - 1); // 1 ms before 3AM next day
  return {
    start: start.toISOString(),
    end: end.toISOString(),
  };
};

export { formatDate, getDayStartISO, getDayEndISO, get3AMRange };
